import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id EE3F2E38-D8CD-42BD-B50F-187A77FBC630
 * name television-pause
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/television-pause.svg
 * tags
 * - Device / Tech 
 */
export const TelevisionPauseIcon = createSvgIcon(<><path d="M3 3C1.89 3 1 3.89 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 23 18.1 23 17V5C23 3.89 22.1 3 21 3M3 5H21V17H3M9 8V14H11V8M13 8V14H15V8" /></>, 'TelevisionPauseIcon');
export default TelevisionPauseIcon